<template>
    <div class="map_area service-page">
        <div class="map_column d-flex" v-animate="'fade-in'" v-for="post in posts" :key="post.id" :id="post.idem">
            <div class="map_column_part">
                <h3 class="map_title" v-html="post.title"></h3>
                <p class="map_text" v-html="post.text"></p>
                <p class="map_address" v-html="post.address"></p>
                <div v-if="post.url" class="fw-bold"><a :href="post.url" target="_blank" class="map_anchor">Official Website</a></div>
            </div>
            <div class="map_column_part hover-anim">
                <div class="map_image img-area">
                    <iframe :src="post.src" style="border:0;" allowfullscreen="" loading="lazy" class="map_iframe"></iframe>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ChinaMaps',
    data() {
        return {
            posts: [
                {
                    idem: 'map1',
                    title: 'oRo TECHNOLOGY (DALIAN) Co., Ltd.',
                    text: '総経理: 李 暁強<br />設立: 2010年1月19日<br />資本金: 70,000米ドル',
                    address: '〒116025<br />中華人民共和国遼寧省大連市高新技術産業園区匯賢園1号04-10.12室',
                    url: 'https://www.oro-dl.cn/',
                    src: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12429.403571344194!2d121.5061393!3d38.8473242!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x358f645dba86525d%3A0xd44e414aca0217f6!2z5aSn6YCj6Luf5Lu25ZyS6aiw6aOb5ZyS5Yy6!5e0!3m2!1sja!2sjp!4v1639445203540!5m2!1sja!2sjp'
                },
                {
                    idem: 'map2',
                    title: 'oRo TECHNOLOGY (DALIAN) Co., Ltd. <br />SHANGHAI BRANCH',
                    address: '〒200051<br />上海市長寧区延安西路1146号3号楼615室',
                    src: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d27300.35128205125!2d121.3956099!3d31.2056571!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35b2654459cff1e9%3A0x7db6b10f919ff50b!2z5rqQ56m66ZaT!5e0!3m2!1sja!2sjp!4v1639445909364!5m2!1sja!2sjp'
                },
                {
                    idem: 'map3',
                    title: 'DALIAN oRo ADVERTISING Co., Ltd.',
                    text: '総経理: 李 暁強<br />設立: 2016年05月06日<br />資本金: 100万人民元',
                    address: '〒116025<br />中華人民共和国遼寧省大連市高新技術産業園区匯賢園1号04-12B<br />(欧楽科技(大連)有限公司事務所内)',
                    src: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12429.403571344194!2d121.5061393!3d38.8473242!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x358f645dba86525d%3A0xd44e414aca0217f6!2z5aSn6YCj6Luf5Lu25ZyS6aiw6aOb5ZyS5Yy6!5e0!3m2!1sja!2sjp!4v1639445203540!5m2!1sja!2sjp'
                }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
    .image {
        width: 100%;
        height: auto;
    }

    .img-area {
            img {
                margin-right: 1rem;
                height: auto;
                -webkit-filter: grayscale(100%);
                -moz-filter: grayscale(100%);
                filter: grayscale(100%);
                transition: all .5s ease;
                object-fit: contain;
                object-position: left;

                &:last-child {
                    margin-right: 0;
                }
            }
        }

    .map_area {
        padding: 0 0 100px 0;
        border-bottom: 1px solid #eeeeee;
    }

    .map_column {
        justify-content: space-between;

        &:not(:first-child) {
            margin-top: 96px;
        }

        &:first-child {
            padding-top: 110px;
        }

        &:nth-child(2) {
            padding-top: 96px;
            margin-top: 0;
        }

        &:last-child {
            border-top: 2px solid #eeeeee;
            padding-top: 109px;
        }
    }

    .map_column_part:first-child {
        width: 58.3%;
        padding-left: 6.8%;
    }

    .map_column_part:last-child {
        width: 41.7%;
    }

    .map_title {
        font-size: 28px;
        margin-bottom: 37px;
    }

    .map_text {
        font-size: 28px;
        font-weight: 500;
        line-height: 1.4;
        margin-bottom: 36px;
    }

    .map_address {
        line-height: 1.8;
        margin-bottom: 0;
    }

    .map_anchor {
        padding-left: 38px;
        display: inline-block;
        position: relative;
        transition: all 0.3s;
        margin-top: 8px;

        &::before {
            content: '';
            display: block;
            width: 25px;
            height: 20px;
            background: url('../../assets/icons/external_2.svg') no-repeat left center;
            background-size: cover;
            position: absolute;
            left: 0;
            top: calc(50% - 10px);
            transition: all 0.3s;
        }

        &:hover {
            color: #000000;
            text-decoration: underline;
        }

        &:hover::before {
            background: url('../../assets/icons/external_2_hover.svg') no-repeat left center;
            background-size: cover;
        }
    }

    .map_image {
        overflow: hidden;
        
        .image {
            transition: all 0.3s;
        }
    }

    .map_image:hover .image {
        transform: scale(1.2);
    }

    .map_iframe {
        width: 100%;
        height: 320px;
    }

    @media screen and (max-width: 767px) {
        .img-area {
            img {
                width: 100% !important;
                margin-right: 0;
                -webkit-filter: none;
                -moz-filter: none;
                filter: none;
                &.sp-mb-1 {
                    margin-bottom: 1rem;
                }
            }
        }
    }

    @media screen and (max-width: 767px) {
        .map_column {
            display: block !important;
            padding-left: 10%;
        }

        .map_column_part:first-child {
            width: 100%;
            margin-bottom: 60px;
            padding-left: 0;
        }

        .map_column_part:last-child {
            width: 100%;
        }

        .map_area {
            padding-top: 100px;
        }

        .map_image:hover .image {
            transform: inherit;
        }
    }
</style>
